import React from 'react';
import { toast } from 'react-toastify';
import { Toast, ToastType } from '@trackman/react-ui';

export const notify = (headline: string, message: string, type: ToastType, className?: string) => {
  toast(
    <Toast headline={headline} visible type={type} dismissCallback={() => {}}>
      {message}
    </Toast>,
    { closeButton: false, className }
  );
};
